import { useMutation, useQuery } from "react-query";

import { Type_Category } from "src/types/category";

import {
    createCategory,
    deleteCategory,
    getCategories,
    updateCategory,
} from "./service";

export const useGetCategories = () => {
    return useQuery({
        queryKey: ["categories"],
        queryFn: () => getCategories(),
        select: (data) => {
            if (!data?.success || !data?.data) {
                throw new Error("Wrong format data: useGetCategories");
            }
            return data.data;
        },
        onError: (err: any) => {
            return err;
        },
    });
};

export const mutationCreateCategory = () => {
    return useMutation({
        mutationFn: (body: Omit<Type_Category, "id">) => createCategory(body),
        onSuccess: async (data) => {
            if (!data?.success || !data) {
                throw new Error("Wrong format data: mutationCreateCategory");
            }
        },
        onError: (err: any) => {
            console.debug("ERROR mutationCreateCategory", err);
            return err;
        },
    });
};

export const mutationUpdateCategory = () => {
    return useMutation({
        mutationFn: async ({
            categoryId,
            body,
        }: {
            categoryId: number;
            body: Partial<Type_Category>;
        }) => updateCategory(categoryId, body),
        onSuccess: async (data) => {
            if (!data?.success || !data) {
                throw new Error("Wrong format data: mutationUpdateCategory");
            }
        },
        onError: (err: any) => {
            console.error("Error in mutationUpdateCategory:", err);
            return err;
        },
    });
};

export const mutationDeleteCategory = () => {
    return useMutation({
        mutationFn: (id: number) => deleteCategory(id),
        onSuccess: async (data) => {
            if (!data?.success || !data) {
                throw new Error("Wrong format data: mutationDeleteCategory");
            }
        },
        onError: (err: any) => {
            console.debug("ERROR mutationDeleteCategory", err);
            return err;
        },
    });
};
